import { render, staticRenderFns } from "./LogoBar.vue?vue&type=template&id=09bb1b98"
import script from "./LogoBar.vue?vue&type=script&lang=ts"
export * from "./LogoBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports